export default __webpack_public_path__ + "static/media/unionpay.9b26e7ee.svg";